<template>
    <v-card style="padding: 0px 10px;">
        <v-toolbar dark dense :class=" aleryType == 'default' ? 'backgroupColorNormal' : aleryType == 'warning' ? 'backgroupColorWarning' : 'backgroupColorError'">
            <!--color="tertiary"-->
            <v-toolbar-title style="white-space: normal;height: auto">
                {{this.alertTitle}}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn title="取消" icon dark @click.native="closeDelete">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text style="font-size: 1rem;margin: 10px">
            <v-icon large color="warning" v-if="aleryType=='warning'">mdi-alert-circle</v-icon>
            <v-icon large color="error" v-if="aleryType=='error'">mdi-close-circle</v-icon>
            <span v-html="alertMsg"></span>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="retry" v-if="alertButton>2">{{button3}}</v-btn>
            <v-btn  @click.native="cancel" v-if="alertButton>1">{{button2}}</v-btn>
            <v-btn  @click.native="confirm">{{button1}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "AlertWin",
        props:{
            alertTitle:{
                type:String,
                default:'系統訊息'
            },
            alertMsg:{
                type:String,
                default:''
            },
            //單鈕 1 (default:確定)  雙鈕 (default: 確定 取消) 三鈕 (default: 確定 取消 重試)
            alertButton:{
                type:Number,
                default:1,
            },
            // default
            aleryType:{
                type:String,
                default:'default',
            },
            button1:{
                type:String,
                default:'確定',
            },
            button2:{
                type:String,
                default:'取消',
            },
            button3:{
                type:String,
                default:'重試',
            },

        },
        data() {
            return {

                // alertLabel

            }
        },

        methods:{
            confirm(){
                this.$emit('confirm');
            },
            cancel(){
                this.$emit('closeDialog');
            },
            retry(){
                this.$emit('retry');
            },
            closeDelete(){
                this.$emit('closeDialog');
            },

        }
    }
</script>

<style scoped>
    .backgroupColorNormal
    {
        background-color: #5BB25F!important;
    }
    .backgroupColorWarning
    {
        background-color: #FFC107!important;
    }
    .backgroupColorError
    {
        background-color: #FF5252!important;
    }

</style>